module.exports = __webpack_public_path__ + "static/media/WellBeing.b59cb1c9.png";